// styled-components based extension
import React from 'react'
import styled from 'styled-components'
import { Image } from '@magicsoup.io/stock'

const Img = styled(Image)`
  height: auto;
  width: ${props => props.width || '100%'};
  display: block;
  border-radius: 2px;
`

Img.defaultProps = {
  as: 'img',
}

export default Img